module.exports = __webpack_public_path__ + "static/media/css-3.621f21fa.png";